<template>
    <div>
        <el-row v-if="!signFlag">
            <el-col :span="16" :offset="4" class="top-title">
                <div v-html="activeData.rule" style="width:100%">
                </div>
            </el-col>
            <el-col :span="24">
                <div style="width: 100%; text-align:center; position:fixed; bottom:10px ;"><el-button type="primary" @click="showSignUp" style="width:50%" round>立即报名</el-button></div>
            </el-col>
        </el-row>
        <el-row v-if="signFlag">
            <el-col :span="16" :offset="4" class="top-title">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="活动名称">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="活动区域">
                        <el-select v-model="form.region" placeholder="请选择活动区域">
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="活动时间">
                        <el-col :span="11">
                        <el-date-picker type="date" placeholder="选择日期" v-model="form.date1" style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                        <el-time-picker placeholder="选择时间" v-model="form.date2" style="width: 100%;"></el-time-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="即时配送">
                        <el-switch v-model="form.delivery"></el-switch>
                    </el-form-item>
                    <el-form-item label="活动性质">
                        <el-checkbox-group v-model="form.type">
                        <el-checkbox label="美食/餐厅线上活动" name="type"></el-checkbox>
                        <el-checkbox label="地推活动" name="type"></el-checkbox>
                        <el-checkbox label="线下主题活动" name="type"></el-checkbox>
                        <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="特殊资源">
                        <el-radio-group v-model="form.resource">
                        <el-radio label="线上品牌商赞助"></el-radio>
                        <el-radio label="线下场地免费"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="活动形式">
                        <el-input type="textarea" v-model="form.desc"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">立即创建</el-button>
                        <el-button>取消</el-button>
                    </el-form-item>
                    </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import { homeworkStuList, getStuHomeworkTags, classMemberList} from '@/api'
    import store from '@/store'
    import Waterfall from '@/components/waterfall'

    export default {
        name: 'Examination',
        components: {
            Waterfall
        },
        props: ['cate', 'words'],
        data() {
            return {

                activeData:{},
                listForm:{
                        'page':1,
                        'limit':99,
                        'where':{}
                },
                form:{
      
                },
                signFlag:false
            }
         
        },
        computed: {
        },
        methods: {
            dataList(clearFlag)
            {
                // if(clearFlag === true)
                // {
                //     this.list = []
                //     this.form.page = 1
                // }
                // homeworkStuList(this.form).then(response => {

                //     if(response.data.length != 0)
                //     {
                //         this.list = this.list.concat(response.data)
                //         this.$refs.Waterfall.isLoading = false
                //     }
     
               
                // })
            },
            showSignUp(){
            this.signFlag = true
        },
        },

        created(){
            var that = this
            store.dispatch('common/loadActiveData');
            this.activeData = store.state.common.activeData

        },
        beforeUnmount() {
        
        },
        beforeDestroy() {
            
        },
        mounted() {
            //this.active_guid = this.$route.query.activeguid

   
          


            this.dataList()

        }
    }
</script>
<style scoped lang="less">

    .change-class-box{
        text-align: right;
        padding-right: 14%;
    }
    .top-title{
        text-align: center;
        font-size:24px;
        margin-top:1vh;
    }

    .examination-box{
        margin-top:5vh;
    }

    .work-box{
        padding:30px;
    }


    .work-title{
        font-size:24px;
        padding-bottom:10px;
    }

    .work-start-time{
        margin-top:10px;
    }

    .work-end-time{
        margin-top:10px;
    }

    .work-teacher-name{
        margin-top:10px;
    }

    .work-img-div{
        padding:10px;
    }

    .work-show-btn{
        font-size: 28px;
        color: #409EFF;
        cursor: pointer;
        margin-top: 65px;
    }

    .work-desc{
        font-size:18px;
    }

    @media (max-width: 1400px) {
        .work-desc{
            font-size:14px;
        }
    }

</style>
